/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import DropZoneContainer from './DropZoneContainer';

const TransformSelectionContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  pointer-events: none;
  width: 100%;
  height: 100%;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
  display: grid;
  grid-template-columns: ${(prop) => `auto 1fr repeat(${prop.col}, 1fr)  1fr auto`};
  grid-template-rows: ${(prop) => `auto 1fr repeat(${prop.row}, 1fr)  1fr auto`};
  z-index: 4;
`;

const TransformSelectionBox = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-column-start: 2;
  grid-row-start: 2;
  grid-column-end: ${(prop) => `${prop.col + 4}`};
  grid-row-end: ${(prop) => `${prop.row + 4}`};
  grid-template-columns: ${(prop) =>
    prop.col === 1
      ? `10% repeat(${prop.col}, 1fr) 10% `
      : prop.col > 8
        ? '1fr repeat(8, 1fr) 1fr '
        : `1fr repeat(${prop.col}, 1fr) 1fr `};
  grid-template-rows: ${(prop) =>
    prop.row === 1
      ? `7% repeat(${prop.row}, 1fr) 7%`
      : prop.row > 12
        ? '1fr repeat(12, 1fr) 1fr '
        : `1fr repeat(${prop.row}, 1fr) 1fr `};
  z-index: 1;
`;

const TransformSelectionWrapper = styled.div`
  grid-column-start: 2;
  grid-row-start: 2;
  grid-column-end: ${(prop) => (prop.col > 8 ? '10' : `${prop.col + 2}`)};
  grid-row-end: ${(prop) => (prop.row > 12 ? '14' : `${prop.row + 2}`)};
  width: 100%;
  height: 100%;
`;

function TransformSelection({
  ID,
  col,
  row,
  onDrag,
  onDrop,
  onHover,
  isDisableDrop,
  onResizeStop,
  onResize,
  onResizeStart,
  layouts,
  setDraggedLayout,
  setDraggedHandle,
  setHoveredWell,
  getEnableHandle,
  hoveredWell,
  wrapperRef,
}) {
  return (
    <TransformSelectionContainer row={col} col={row}>
      <TransformSelectionBox row={col} col={row}>
        <TransformSelectionWrapper ref={wrapperRef} row={col} col={row}>
          <DropZoneContainer
            dropZoneID={ID}
            layouts={layouts}
            row={row}
            col={col}
            onDrop={onDrop}
            onDrag={onDrag}
            onHover={onHover}
            isDisableDrop={isDisableDrop}
            onResizeStop={onResizeStop}
            onResize={onResize}
            onResizeStart={onResizeStart}
            setDraggedLayout={setDraggedLayout}
            setDraggedHandle={setDraggedHandle}
            setHoveredWell={setHoveredWell}
            hoveredWell={hoveredWell}
            getEnableHandle={getEnableHandle}
          />
        </TransformSelectionWrapper>
      </TransformSelectionBox>
    </TransformSelectionContainer>
  );
}

TransformSelection.propTypes = {
  ID: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  row: PropTypes.number.isRequired,
  layouts: PropTypes.object,
  onDrag: PropTypes.func,
  onDrop: PropTypes.func,
  onHover: PropTypes.func,
  isDisableDrop: PropTypes.func,
  onResizeStart: PropTypes.func,
  onResize: PropTypes.func,
  onResizeStop: PropTypes.func,
  setDraggedLayout: PropTypes.func,
  setDraggedHandle: PropTypes.func,
  setHoveredWell: PropTypes.func,
  getEnableHandle: PropTypes.func,
  hoveredWell: PropTypes.object,
  wrapperRef: PropTypes.any,
};

TransformSelection.defaultProps = {
  layouts: {},
  onDrag: () => {},
  onDrop: () => {},
  onHover: () => {},
  isDisableDrop: () => false,
  onResizeStart: () => {},
  onResize: () => {},
  onResizeStop: () => {},
  setDraggedLayout: () => {},
  setDraggedHandle: () => {},
  setHoveredWell: () => {},
  getEnableHandle: () => {},
  hoveredWell: {},
  wrapperRef: null,
};

export default TransformSelection;
